<template>
	<div class="form-radio" @click.prevent="onClick">
		<label>
			<div class="form-radio__label">${{value}}</div>
			<input
				ref="radio"
				type="radio"
				:name="name"
				:value="value"
				:checked="checked"
			/>
			<span></span>
		</label>
	</div>
</template>

<script>
export default {
	props: {
		name: {
			type: String,
			default: '',
		},
		value: {
			type: String,
			default: '',
		},
		selected: {
			type: Boolean,
			default: false,
		},
	},
	data () {
		return {
			checked: this.selected,
		};
	},
	methods: {
		onClick () {
			this.checked = !this.checked;
			if (this.checked) {
				this.$emit('change', this.value);
			} else {
				this.$emit('change', 0);
			}
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../assets/less/default.less';

	.form-radio {
		&__label { .size(40px); margin-bottom: 0.6rem; background-color: @blue; color: white; .bold(); text-align: center; line-height: 40px; }
		input { display: none; }
		input + span { display: inline-block; .size(25px); border: 3px solid white; background-color: #fff; vertical-align: middle; }
		input:checked + span { background-color: @blue; }
	}
</style>



// WEBPACK FOOTER //
// src/components/BaseRadio.vue